import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .directive('autocompleteTouchFix', autocompleteTouchFix);

function autocompleteTouchFix() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      // Wait for internal input to exist
      setTimeout(() => {
        const input = element[0].querySelector('input');
        if (!input) return;

        input.addEventListener('touchstart', function(e) {
          e.stopPropagation(); // Prevent blur triggered by touch
        }, { passive: false }); // Use passive: false to allow preventDefault if needed
      });
    }
  };
}
